<template>
  <div>
    <section class="success-section">
      <div class="header">
        <v-icon size="35" class="icon" :color="paramsIcon.color">
          {{ paramsIcon.icon }}
        </v-icon>
        <div class="d-flex flex-column">
          <span class="title">
            {{ description }}
          </span>
          <!-- <span class="sub-title">Результаты заявления будут отправлены в личный кабинет в течении двух недель. </span> -->
        </div>
      </div>
    </section>
    <div class="mt-10">
      <template>
        <slot name="default">
          <v-btn
              depressed
              color="primary"
              class="button-base"
              @click="goToStatementsList"
          >Перейти в Мои заявления
          </v-btn>
        </slot>
      </template>
    </div>
  </div>
</template>

<script>
import { mdiCheckCircleOutline, mdiAlertOutline  } from '@mdi/js';
import { RouteName } from '@/router';

export const TypeIcon = {
  SUCCESS: 'SUCCESS',
  ALERT: 'ALERT',
};

const DictionaryIcon = {
  SUCCESS: {
    icon: mdiCheckCircleOutline,
    color: '#52C41A',
  },
  ALERT: {
    icon: mdiAlertOutline,
    color: '#52C41A',
  },
};

export default {
  name: 'StepSuccess',
  props: {
    typeIcon: {
      type: String,
      default: 'SUCCESS',
    },
    description: {
      type: String,
      default: 'Ваше заявление отправлено в Единую информационную систему нотариата',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    paramsIcon() {
      return DictionaryIcon[this.typeIcon];
    },
  },
  methods: {
    goToStatementsList() {
      this.$router.push({
        name: RouteName.STATEMENTS,
        params: {},
      });
    },
  },
};
</script>

<style scoped lang="scss">
.success-section {
  border: 1px solid $color-dark-grey;
  padding: 20px 100px 20px 40px;
  width: fit-content;

  &--history {
    border: none;
    padding: 0;
    width: 100%;
  }

  & .title {
    font-weight: 600;
    color: $color-base;
    font-size: $font-size-middle-level-2 !important;
  }

  & .header {
    display: flex;
    flex-direction: row;
    align-items: center;

    & .icon {
      margin-right: 10px;
    }

    & .sub-title {
      color: $color-base;
      font-size: $font-size-small !important;
    }
  }
}
</style>
